import React from "react";
import styled from "styled-components";
import { Input, Modal } from "@arco-design/web-react";
import { isBlank } from "../utils/validators";

// The free-form Campaign Type isn't used anywhere yet, so it's hidden.
const SHOW_CAMPAIGN_TYPE = false;

// MUI Dialog + TextField -> Arco Modal + Input. The render-prop API, state, and
// onSave payload are unchanged. Arco Input onChange passes the value (not an
// event). The MUI label becomes a styled label above each field.

const Field = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
`;

const FieldLabel = styled.div`
  font-size: 12px;
  color: var(--color-text-3);
  margin-bottom: 4px;
`;

export default function CampaignDialog({ data, render, onSave }) {
  const [open, setOpen] = React.useState(false);
  const [campaignName, setCampaignName] = React.useState("");
  const [confirmEmailUrl, setConfirmEmailUrl] = React.useState("");
  const [unsubscribeEmailUrl, setUnsubscribeEmailUrl] = React.useState("");
  const [senderEmail, setSenderEmail] = React.useState("");
  const [campaignType, setCampaignType] = React.useState("");


  const handleClickOpen = () => {
    setOpen(true);
    setCampaignName(data ? data.name: "");
    setConfirmEmailUrl(data ? data.confirm_email_url : "")
    setUnsubscribeEmailUrl(data ? data.unsubscribe_email_url: "")
    setSenderEmail(data ? data.sender_email: "")
    setCampaignType(data ? data.type : "")
  };

  const handleClose = () => {
    setOpen(false);
  };

  const isValid = !isBlank(campaignName);

  const handleSave = () => {
    if (!isValid) {
      return;
    }
    onSave && onSave({
      name: campaignName,
      confirm_email_url: confirmEmailUrl,
      unsubscribe_email_url: unsubscribeEmailUrl,
      sender_email: senderEmail,
      type: campaignType,
    });
    handleClose();
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSave();
    }

    return false;
  }

  return (
    <>
      {render(handleClickOpen)}
      <Modal
        visible={open}
        onCancel={handleClose}
        onOk={handleSave}
        title={`${data ? "Edit" : "Add"} Campaign `}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{ disabled: !isValid }}
      >
        <Field>
          <FieldLabel>Name</FieldLabel>
          <Input
            autoFocus
            value={campaignName}
            onChange={(v) => {
              setCampaignName(v);
            }}
          />
        </Field>

        {/* Campaign Type is hidden while nothing uses it (its value is kept as-is). */}
        {SHOW_CAMPAIGN_TYPE && (
          <Field>
            <FieldLabel>Campaign Type</FieldLabel>
            <Input
              value={campaignType}
              onChange={(v) => {
                setCampaignType(v);
              }}
              onKeyDownCapture={handleKeyPress}
            />
          </Field>

        )}
      </Modal>
    </>
  );
}
